import { Box, Checkbox, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import classes from 'styles/globalStyle.module.scss';
import { defaultFn, numberToCurrency } from 'utils/utility';

const StandardOptions = ({
  year,
  make,
  model,
  series,
  style,
  totalInvoice,
  totalmsrp,
  groupedByCategory,
  selectedRows,
  handleCheckboxChange,
}) => {
  return (
    <>
      <Typography variant="caption" sx={{ fontSize: '14px!important', fontWeight: 700 }}>
        Select options for {year} {make} {model} {series} {style} - Spec{' '}
      </Typography>
      <Box
        role="table"
        display="flex"
        flexDirection="column"
        className={classes.tableOutline}
        mt={2}
      >
        <Box
          display="flex"
          gap={2}
          sx={{ backgroundColor: '#f2f2f2' }}
          p={2}
          className={classes.borderTable}
          role="row"
        >
          <Typography
            role="columnheader"
            sx={{ flexGrow: 1, fontWeight: 700, paddingLeft: '30px' }}
          >
            Description
          </Typography>
          <Typography
            role="columnheader"
            sx={{ minWidth: '15%', maxWidth: '15%', fontWeight: 700 }}
          >
            Invoice
          </Typography>
          <Typography
            role="columnheader"
            sx={{ minWidth: '15%', maxWidth: '15%', fontWeight: 700 }}
          >
            MSRP
          </Typography>
        </Box>
        {Object.keys(groupedByCategory).map((category) => (
          <Box
            display="flex"
            flexDirection="column"
            key={category}
            id={`${category}-category`}
            className={classes.childBorderLine}
            role="rowgroup"
          >
            <Typography
              sx={{
                backgroundColor: '#F9F9F9;',
                padding: '16px',
                paddingLeft: '40px',
                fontWeight: 700,
              }}
              className={classes.borderTable}
              role="row"
            >
              {category}
            </Typography>
            {groupedByCategory[category]?.map?.((x) => {
              const { description, invoice, retail, statusCode, includeOptionFlag, seqNumber } = x;
              return (
                <Box display="flex" gap={2} key={seqNumber} p={2} role="row">
                  <Checkbox
                    color="secondary"
                    checked={!!selectedRows.find((el) => el.seqNumber === seqNumber)}
                    onChange={(event) => handleCheckboxChange(event, x)}
                    disabled={statusCode === 'R' || includeOptionFlag === true}
                  />
                  <Typography sx={{ flexGrow: 1 }} role="cell">
                    {description}
                  </Typography>
                  <Typography sx={{ minWidth: '15%', maxWidth: '15%' }} role="cell">
                    {numberToCurrency(invoice)}
                  </Typography>
                  <Typography sx={{ minWidth: '15%', maxWidth: '15%' }} role="cell">
                    {numberToCurrency(retail)}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        ))}
        <Box
          display="flex"
          gap={2}
          sx={{ backgroundColor: '#f2f2f2' }}
          p={1}
          className={classes.borderTable}
          id="total-adjustments"
          role="row"
        >
          <Typography
            role="cell"
            sx={{ flexGrow: 1, fontWeight: 700, padding: '16px', paddingLeft: '30px' }}
          >
            Total Adjustments
          </Typography>
          <Typography
            sx={{ minWidth: '15%', maxWidth: '15%', fontWeight: 700, padding: '16px 0px' }}
          >
            {numberToCurrency(totalInvoice)}
          </Typography>
          <Typography
            role="cell"
            sx={{ minWidth: '15%', maxWidth: '15%', fontWeight: 700, padding: '16px 0px' }}
          >
            {numberToCurrency(totalmsrp)}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default StandardOptions;

StandardOptions.propTypes = {
  year: PropTypes.string,
  make: PropTypes.string,
  model: PropTypes.string,
  series: PropTypes.string,
  style: PropTypes.string,
  totalInvoice: PropTypes.number,
  totalmsrp: PropTypes.number,
  groupedByCategory: PropTypes.instanceOf(Object),
  selectedRows: PropTypes.instanceOf(Object),
  handleCheckboxChange: PropTypes.func,
};
StandardOptions.defaultProps = {
  year: '',
  make: '',
  model: '',
  series: '',
  style: '',
  totalInvoice: 0,
  totalmsrp: 0,
  groupedByCategory: [],
  selectedRows: [],
  handleCheckboxChange: defaultFn,
};
